import CardinalLogo from '../assets/images/themeImages/cardinal.png';
import FunctionLogo from '../assets/images/themeImages/function.png';
import BeaconbioLogo from '../assets/images/themeImages/beaconbio.png';
import EclipseLogo from '../assets/images/themeImages/eclipse.png';
import HytestLogo from '../assets/images/themeImages/hytest.png';
import CatalentLogo from '../assets/images/themeImages/catalent.png';
import MinarisLogo from '../assets/images/themeImages/minaris.png';
import CardinalWhite from '../assets/images/themeImages/cardinal-white-logo.png';
import BeaconBioWhite from '../assets/images/themeImages/beaconbio-white-logo.png';
import EclipseWhite from '../assets/images/themeImages/eclipse-white-logo.png';
import HytestWhite from '../assets/images/themeImages/hytest-white-logo.png';
import CatalentWhite from '../assets/images/themeImages/catalent-white-logo.png';
import FunctionWhite from '../assets/images/themeImages/function-white-logo.png';
import MinarisWhite from '../assets/images/themeImages/minaris-white-logo.png';
import HoneybeeWhite from '../assets/images/themeImages/honeybee-white-logo.png';
import HoneybeeLogo from '../assets/images/themeImages/honeybee.png';
import EmberLogo from '../assets/images/themeImages/ember.png';
import EmberWhite from '../assets/images/themeImages/ember-white-logo.png';
import VerilyLogo from '../assets/images/themeImages/verily.png';
import VerilyWhite from '../assets/images/themeImages/verily-white-logo.png';
import CullinanLogo from '../assets/images/themeImages/CullinanLogo.png';
import CullinanWhite from '../assets/images/themeImages/CullinanWhite.png';
import Axelliant from '../assets/images/themeImages/axelliant.png';
import ArvatoColorLogo from '../assets/images/themeImages/ArvatoColorLogo.png'; // arvato color logo
import ArvatoWhiteLogo from '../assets/images/themeImages/ArvatoWhiteLogo.png'; // arvato white logo
import FS2ColorLogo from '../assets/images/themeImages/FS2ColorLogo.png'; // FS2 color logo
import FS2WhiteLogo from '../assets/images/themeImages/FS2WhiteLogo.png'; // FS2 white logo
import ProgressLogo from '../assets/images/themeImages/progressLogo.png';
import ProgressWhite from '../assets/images/themeImages/progress-white.png';
import WorldCourierLogo from '../assets/images/themeImages/worldCourierLogo.png';
import WorldCourierWhite from '../assets/images/themeImages/worldCourierWhite.png';
import GenetixLogo from '../assets/images/themeImages/genetix.png';
import GenetixWhiteLogo from '../assets/images/themeImages/genetix-white-logo.png';
import CevaLogo from '../assets/images/themeImages/ceva.png';
import UnipharLogo from '../assets/images/themeImages/uniphar.png';
import Geodis from '../assets/images/themeImages/geodis.png';
import Kite from '../assets/images/themeImages/Kite.png';
import Moonlight from '../assets/images/themeImages/Moonlight.png';
import Tscan from '../assets/images/themeImages/tscan.png';
import TscanWhiteLogo from '../assets/images/themeImages/tscanWhiteLogo.png';
import NuBioAgeLogo from '../assets/images/themeImages/nuBioAge.png';
import SmartWaysLogo from '../assets/images/themeImages/smartways.png';
import CedarsLogo from '../assets/images/themeImages/cedars.png';
import ValarAtomicsLogo from '../assets/images/themeImages/valar-atomics.png';
import BedrockRoboticsLogo from '../assets/images/themeImages/bedrock-robotics.png';
import IntelliaLogo from '../assets/images/themeImages/intellia-therapeutics.png';
import PeakEnergyLogo from '../assets/images/themeImages/peak-energy.png';
import PfizerLogo from '../assets/images/themeImages/pfizerLogo.png';
import RxLogiWhiteLogo from '../assets/images/themeImages/rxlogi-logo-white.png';
import RxLogiLogo from '../assets/images/themeImages/rxlogi-logo.png';

export interface AppTheme {
  primary: string;
  activeIcon?: string;
  text: string;
  color: string;
  activeRouteBg?: string;
  title: string;
  themeType: number;
  headerLogo: string;
  whiteLogo: string;
  shareUrl: string;
  headerLogoWidth: string;
  loginLogoWidth: string;
  authHeaderLogoWidth: string;
  whiteLogoFilter?: string;
  loginLogoMarginRight?: string;
}

const cardinalTheme: AppTheme = {
  primary: '#e41f35',
  activeIcon: '#e41f35',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'CardinalHealth',
  themeType: 2,
  headerLogo: CardinalLogo,
  whiteLogo: CardinalWhite,
  shareUrl: 'https://cardinalhealth.zoomlogi.com/',
  headerLogoWidth: '145px',
  loginLogoWidth: '145px',
  authHeaderLogoWidth: '145px',
  loginLogoMarginRight: '50px',
};

const catalentTheme: AppTheme = {
  primary: '#136ba8',
  activeIcon: '#136ba8',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Catalent',
  themeType: 3,
  headerLogo: CatalentLogo,
  whiteLogo: CatalentWhite,
  shareUrl: 'https://catalent.zoomlogi.com/',
  headerLogoWidth: '75px',
  loginLogoWidth: '75px',
  authHeaderLogoWidth: '100px',
  loginLogoMarginRight: '5px',
};

const beaconbioTheme: AppTheme = {
  primary: '#5544E7',
  activeIcon: '#5544E7',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Beacon Biosignals',
  themeType: 4,
  headerLogo: BeaconbioLogo,
  whiteLogo: BeaconBioWhite,
  shareUrl: 'https://beaconbio.zoomlogi.com/',
  headerLogoWidth: '100px',
  loginLogoWidth: '100px',
  authHeaderLogoWidth: '100px',
  loginLogoMarginRight: '0px',
};

const eclipseTheme: AppTheme = {
  primary: '#AC7908',
  activeIcon: '#AC7908',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Eclipse',
  themeType: 5,
  headerLogo: EclipseLogo,
  whiteLogo: EclipseWhite,
  shareUrl: 'https://eclipse.zoomlogi.com/',
  headerLogoWidth: '75px',
  loginLogoWidth: '100px',
  authHeaderLogoWidth: '85px',
  loginLogoMarginRight: '0px',
};

const hytestTheme: AppTheme = {
  primary: '#103666',
  activeIcon: '#103666',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Hytest',
  themeType: 6,
  headerLogo: HytestLogo,
  whiteLogo: HytestWhite,
  shareUrl: 'https://hytest.zoomlogi.com/',
  headerLogoWidth: '100px',
  loginLogoWidth: '100px',
  authHeaderLogoWidth: '100px',
  loginLogoMarginRight: '0px',
};

const functionTheme: AppTheme = {
  primary: '#C07858',
  activeIcon: '#C07858',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'FunctionHealth',
  themeType: 7,
  headerLogo: FunctionLogo,
  whiteLogo: FunctionWhite,
  shareUrl: 'https://functionhealth.zoomlogi.com/',
  headerLogoWidth: '100px',
  loginLogoWidth: '100px',
  authHeaderLogoWidth: '100px',
  loginLogoMarginRight: '0px',
};

const MinarisTheme: AppTheme = {
  primary: '#122960',
  activeIcon: '#122960',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Minaris',
  themeType: 8,
  headerLogo: MinarisLogo,
  whiteLogo: MinarisWhite,
  shareUrl: 'https://minaris.zoomlogi.com/',
  headerLogoWidth: '100px',
  loginLogoWidth: '100px',
  authHeaderLogoWidth: '100px',
  loginLogoMarginRight: '10px',
};

const HoneybeeTheme: AppTheme = {
  primary: '#00B7A6',
  activeIcon: '#00B7A6',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'HoneyBee',
  themeType: 9,
  headerLogo: HoneybeeLogo,
  whiteLogo: HoneybeeWhite,
  shareUrl: 'https://honeybee.zoomlogi.com/',
  headerLogoWidth: '100px',
  loginLogoWidth: '100px',
  authHeaderLogoWidth: '110px',
  loginLogoMarginRight: '0px',
};

const EmberTheme: AppTheme = {
  primary: '#000000',
  activeIcon: '#000000',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Ember',
  themeType: 10,
  headerLogo: EmberLogo,
  whiteLogo: EmberWhite,
  shareUrl: 'https://ember.zoomlogi.com/',
  headerLogoWidth: '175px',
  loginLogoWidth: '175px',
  authHeaderLogoWidth: '175px',
  loginLogoMarginRight: '0px',
};

const VerilyTheme: AppTheme = {
  primary: '#087A6A',
  activeIcon: '#087A6A',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Verily',
  themeType: 11,
  headerLogo: VerilyLogo,
  whiteLogo: VerilyWhite,
  shareUrl: 'https://verily.zoomlogi.com/',
  headerLogoWidth: '110px',
  loginLogoWidth: '110px',
  authHeaderLogoWidth: '110px',
  loginLogoMarginRight: '0px',
};

const CullinanTherapeuticsTheme: AppTheme = {
  primary: '#01416F',
  activeIcon: '#01416F',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Cullinan Therapeutics',
  themeType: 12,
  headerLogo: CullinanLogo,
  whiteLogo: CullinanWhite,
  shareUrl: 'https://cullinantherapeutics.zoomlogi.com/',
  headerLogoWidth: '90px',
  loginLogoWidth: '90px',
  authHeaderLogoWidth: '90px',
  loginLogoMarginRight: '0px',
};
// theme type 13
const FS2Theme: AppTheme = {
  primary: '#3095FF',
  activeIcon: '#3095FF',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'FS2',
  themeType: 13,
  headerLogo: FS2ColorLogo,
  whiteLogo: FS2WhiteLogo,
  shareUrl: 'https://fs2.zoomlogi.com/',
  headerLogoWidth: '104px',
  loginLogoWidth: '104px',
  authHeaderLogoWidth: '97px',
  loginLogoMarginRight: '0px',
};
// theme type 14
const ArvatoTheme: AppTheme = {
  primary: '#0779B5',
  activeIcon: '#0779B5',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Arvato',
  themeType: 14,
  headerLogo: ArvatoColorLogo,
  whiteLogo: ArvatoWhiteLogo,
  shareUrl: 'https://arvato.zoomlogi.com/',
  headerLogoWidth: '114px',
  loginLogoWidth: '114px',
  authHeaderLogoWidth: '107px',
  loginLogoMarginRight: '0px',
};
// theme type 15
const ProgressPharmacyTheme: AppTheme = {
  primary: '#32534A',
  activeIcon: '#32534A',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Progress Pharmacy',
  themeType: 15,
  headerLogo: ProgressLogo,
  whiteLogo: ProgressWhite,
  shareUrl: 'https://progresspharmacy.zoomlogi.com/',
  headerLogoWidth: '114px',
  loginLogoWidth: '114px',
  authHeaderLogoWidth: '107px',
  loginLogoMarginRight: '0px',
};
// theme type 16
const WorldCourierTheme: AppTheme = {
  primary: '#3C289B',
  activeIcon: '#3C289B',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Cencora World Courier',
  themeType: 16,
  headerLogo: WorldCourierLogo,
  whiteLogo: WorldCourierWhite,
  shareUrl: 'https://worldcourier.zoomlogi.com/',
  headerLogoWidth: '114px',
  loginLogoWidth: '114px',
  authHeaderLogoWidth: '120px',
  loginLogoMarginRight: '0px',
};
// theme type 17
const GenetixTheme: AppTheme = {
  primary: '#1452AD',
  activeIcon: '#1452AD',
  text: '#000',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Genetix',
  themeType: 17,
  headerLogo: GenetixLogo,
  whiteLogo: GenetixWhiteLogo,
  shareUrl: 'https://genetix.zoomlogi.com/',
  headerLogoWidth: '114px',
  loginLogoWidth: '114px',
  authHeaderLogoWidth: '125px',
  loginLogoMarginRight: '0px',
};

// theme type 18
const CevaTheme: AppTheme = {
  primary: '#021D49',
  activeIcon: '#021D49',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'CEVA Logistics',
  themeType: 18,
  headerLogo: CevaLogo,
  whiteLogo: CevaLogo,
  shareUrl: 'https://ceva.zoomlogi.com/',
  headerLogoWidth: '89px',
  loginLogoWidth: '89px',
  authHeaderLogoWidth: '120px',
  whiteLogoFilter: 'brightness(0) invert(1)',
  loginLogoMarginRight: '10px',
};

// theme type 19
const UnipharTheme: AppTheme = {
  primary: '#263745',
  activeIcon: '#263745',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Uniphar Logistics',
  themeType: 19,
  headerLogo: UnipharLogo,
  whiteLogo: UnipharLogo,
  shareUrl: 'https://uniphar.zoomlogi.com/',
  headerLogoWidth: '91px',
  loginLogoWidth: '91px',
  authHeaderLogoWidth: '125px',
  whiteLogoFilter: 'brightness(0) invert(1)',
  loginLogoMarginRight: '0px',
};

// theme type 20
const GeodisTheme: AppTheme = {
  primary: '#3200E6',
  activeIcon: '#3200E6',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Geodis',
  themeType: 20,
  headerLogo: Geodis,
  whiteLogo: Geodis,
  shareUrl: 'https://geodis.zoomlogi.com/',
  headerLogoWidth: '91px',
  loginLogoWidth: '91px',
  authHeaderLogoWidth: '105px',
  whiteLogoFilter: 'brightness(0) invert(1)',
  loginLogoMarginRight: '10px',
};

// theme type 21
const KiteTheme: AppTheme = {
  primary: '#0B64A6',
  activeIcon: '#0B64A6',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Kite Pharma',
  themeType: 21,
  headerLogo: Kite,
  whiteLogo: Kite,
  shareUrl: 'https://kitepharma.zoomlogi.com/',
  headerLogoWidth: '91px',
  loginLogoWidth: '91px',
  authHeaderLogoWidth: '105px',
  whiteLogoFilter: 'brightness(0) invert(1)',
  loginLogoMarginRight: '50px',
};

// theme type 22
const AxelliantTheme: AppTheme = {
  primary: '#00579A',
  activeIcon: '#00579A',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Axelliant',
  themeType: 22,
  headerLogo: Axelliant,
  whiteLogo: Axelliant,
  shareUrl: 'https://axelliant.zoomlogi.com/',
  headerLogoWidth: '140px',
  loginLogoWidth: '140px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '145px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 23
const MoonLightTheme: AppTheme = {
  primary: '#EF6748',
  activeIcon: '#EF6748',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Moonlight Bio',
  themeType: 23,
  headerLogo: Moonlight,
  whiteLogo: Moonlight,
  shareUrl: 'https://moonlightbio.zoomlogi.com/',
  headerLogoWidth: '95px',
  loginLogoWidth: '95px',
  loginLogoMarginRight: '5px',
  authHeaderLogoWidth: '95px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 24
const TscanTheme: AppTheme = {
  primary: '#393582',
  activeIcon: '#393582',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#25315c',
  title: 'Tscan',
  themeType: 24,
  headerLogo: Tscan,
  whiteLogo: TscanWhiteLogo,
  shareUrl: 'https://tscan.zoomlogi.com/',
  headerLogoWidth: '100px',
  loginLogoWidth: '100px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '100px',
};

// theme type 25
const NuBioAgeTheme: AppTheme = {
  primary: '#3184FB',
  activeIcon: '#3184FB',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'nuBioAge',
  themeType: 25,
  headerLogo: NuBioAgeLogo,
  whiteLogo: NuBioAgeLogo,
  shareUrl: 'https://nubioage.zoomlogi.com/',
  headerLogoWidth: '110px',
  loginLogoWidth: '110px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '110px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 26
const SmartWaysTheme: AppTheme = {
  primary: '#002855',
  activeIcon: '#002855',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'SmartWays',
  themeType: 26,
  headerLogo: SmartWaysLogo,
  whiteLogo: SmartWaysLogo,
  shareUrl: 'https://smartways.zoomlogi.com/',
  headerLogoWidth: '150px',
  loginLogoWidth: '200px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '150px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 27
const CedarsSinaiTheme: AppTheme = {
  primary: '#DC1F34',
  activeIcon: '#DC1F34',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Cedars Sinai',
  themeType: 27,
  headerLogo: CedarsLogo,
  whiteLogo: CedarsLogo,
  shareUrl: 'https://cedars-sinai.zoomlogi.com/',
  headerLogoWidth: '100px',
  loginLogoWidth: '125px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '100px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 28
const ValarAtomicsTheme: AppTheme = {
  primary: '#000',
  activeIcon: '#000',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Valar Atomics',
  themeType: 28,
  headerLogo: ValarAtomicsLogo,
  whiteLogo: ValarAtomicsLogo,
  shareUrl: 'https://valaratomics.zoomlogi.com/',
  headerLogoWidth: '130px',
  loginLogoWidth: '150px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '130px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 29
const BedrockRoboticsTheme: AppTheme = {
  primary: '#8C8073',
  activeIcon: '#8C8073',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Bedrock Robotics',
  themeType: 29,
  headerLogo: BedrockRoboticsLogo,
  whiteLogo: BedrockRoboticsLogo,
  shareUrl: 'https://bedrockrobotics.zoomlogi.com/',
  headerLogoWidth: '150px',
  loginLogoWidth: '180px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '150px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 30
const IntelliaTherapeuticsTheme: AppTheme = {
  primary: '#D3461E',
  activeIcon: '#D3461E',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Intelliatx',
  themeType: 30,
  headerLogo: IntelliaLogo,
  whiteLogo: IntelliaLogo,
  shareUrl: 'https://intelliatx.zoomlogi.com/',
  headerLogoWidth: '118px',
  loginLogoWidth: '150px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '118px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 31
const PeakEnergyTheme: AppTheme = {
  primary: '#000',
  activeIcon: '#000',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Peak Energy',
  themeType: 31,
  headerLogo: PeakEnergyLogo,
  whiteLogo: PeakEnergyLogo,
  shareUrl: 'https://peakenergy.zoomlogi.com/',
  headerLogoWidth: '132px',
  loginLogoWidth: '165px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '132px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 32
const PfizerTheme: AppTheme = {
  primary: '#0000C9',
  activeIcon: '#0000C9',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Pfizer',
  themeType: 32,
  headerLogo: PfizerLogo,
  whiteLogo: PfizerLogo,
  shareUrl: 'https://pfizer.zoomlogi.com/',
  headerLogoWidth: '99px',
  loginLogoWidth: '140px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '99px',
  whiteLogoFilter: 'brightness(0) invert(1)',
};

// theme type 33
const RxLogiTheme: AppTheme = {
  primary: '#0E8C84',
  activeIcon: '#0E8C84',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'RxLogi',
  themeType: 33,
  headerLogo: RxLogiLogo,
  whiteLogo: RxLogiWhiteLogo,
  shareUrl: 'https://rxlogi.zoomlogi.com/',
  headerLogoWidth: '140px',
  loginLogoWidth: '175px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '140px',
};

// theme type 34
const EnvirotainerTheme: AppTheme = {
  primary: '#002796',
  activeIcon: '#002796',
  text: '#fff',
  color: 'white',
  activeRouteBg: '#fff',
  title: 'Envirotainer',
  themeType: 34,
  headerLogo: '',
  whiteLogo: '',
  shareUrl: 'https://envirotainer.zoomlogi.com/',
  headerLogoWidth: '140px',
  loginLogoWidth: '175px',
  loginLogoMarginRight: '10px',
  authHeaderLogoWidth: '140px',
};

const defaultTheme: AppTheme = {
  primary: '#020922',
  activeIcon: '#fff',
  text: '#2248D2',
  color: 'white',
  activeRouteBg: '#25315C',
  title: 'Zoomlogi',
  themeType: 1,
  headerLogo: '',
  whiteLogo: '',
  shareUrl: process.env.REACT_APP_BASE_URL ?? '',
  headerLogoWidth: '100px',
  loginLogoWidth: '',
  authHeaderLogoWidth: '',
  loginLogoMarginRight: '0px',
};

const themeMap: Record<string, AppTheme> = {
  '2': cardinalTheme,
  '3': catalentTheme,
  '4': beaconbioTheme,
  '5': eclipseTheme,
  '6': hytestTheme,
  '7': functionTheme,
  '8': MinarisTheme,
  '9': HoneybeeTheme,
  '10': EmberTheme,
  '11': VerilyTheme,
  '12': CullinanTherapeuticsTheme,
  '13': FS2Theme,
  '14': ArvatoTheme,
  '15': ProgressPharmacyTheme,
  '16': WorldCourierTheme,
  '17': GenetixTheme,
  '18': CevaTheme,
  '19': UnipharTheme,
  '20': GeodisTheme,
  '21': KiteTheme,
  '22': AxelliantTheme,
  '23': MoonLightTheme,
  '24': TscanTheme,
  '25': NuBioAgeTheme,
  '26': SmartWaysTheme,
  '27': CedarsSinaiTheme,
  '28': ValarAtomicsTheme,
  '29': BedrockRoboticsTheme,
  '30': IntelliaTherapeuticsTheme,
  '31': PeakEnergyTheme,
  '32': PfizerTheme,
  '33': RxLogiTheme,
  '34': EnvirotainerTheme,
};

export const resolveTheme = (themeType?: string): AppTheme =>
  themeMap[themeType ?? ''] || defaultTheme;

const theme = resolveTheme(process.env.REACT_APP_THEME_TYPE);

export default theme;
